<template>
  <el-dialog
    top="100px"
    width="800px"
    :title="$t('page.personalInfo.title')"
    append-to-body
    :visible="personalInfoVisible"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <el-form
      v-if="userInfo"
      :inline="true"
      label-suffix="："
      label-position="right"
      label-width="120px"
    >
      <el-form-item :label="$t('page.personalInfo.userName')">
        <div class="item">{{ userInfo.fullname }}</div>
      </el-form-item>

      <el-form-item :label="$t('page.personalInfo.userAccount')">
        <div class="item">{{ userInfo.account }}</div>
      </el-form-item>

      <el-form-item :label="$t('page.personalInfo.phoneNumber')">
        <div class="item">{{ userInfo.mobile }}</div>
      </el-form-item>

      <el-form-item :label="$t('page.personalInfo.email')">
        <div class="item">{{ userInfo.email }}</div>
      </el-form-item>

      <el-form-item :label="$t('page.personalInfo.userGender')">
        <div class="item">{{ userInfo.sex }}</div>
      </el-form-item>

      <el-form-item :label="$t('page.personalInfo.userStatus')">
        <div class="item">{{ getUserStatus(userInfo.status) }}</div>
      </el-form-item>

      <el-form-item
        :label="$t('page.personalInfo.address')"
        style="width: 100%"
      >
        <div class="item" style="width: 632px">{{ userInfo.address }}</div>
      </el-form-item>

      <el-form-item style="width: 100%" :label="$t('page.personalInfo.role')">
        <div v-if="roleInfo.roleName">
          <span v-for="name in roleInfo" :key="name">
            <el-tag type="warning">{{ name }}</el-tag>
          </span>
        </div>
      </el-form-item>

      <el-form-item
        style="width: 100%"
        :label="$t('page.personalInfo.position')"
      >
        <el-tooltip
          v-for="post in postInfo"
          :key="post.postId"
          placement="top"
          :content="post.pathName"
        >
          <el-tag type="success">{{ post.postName }}</el-tag>
        </el-tooltip>
      </el-form-item>

      <el-form-item
        style="width: 100%"
        :label="$t('page.personalInfo.organization')"
      >
        <el-tooltip
          v-for="org in orgInfo"
          :key="org.orgId"
          placement="top"
          :content="org.pathName"
        >
          <el-tag>{{ org.orgName }}</el-tag>
        </el-tooltip>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
  export default {
    name: 'PersonalInfo',
    props: {
      accountInfo: {
        type: Object,
        default: null,
      },
      personalInfoVisible: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        orgInfo: [],
        postInfo: {},
        roleInfo: {},
        userInfo: {},
      }
    },
    watch: {
      personalInfoVisible(val) {
        if (val && this.accountInfo) {
          this.orgInfo = this.accountInfo.org
          this.postInfo = this.accountInfo.post
          this.roleInfo = this.accountInfo.role
          this.userInfo = this.accountInfo.user
        }
      },
    },
    methods: {
      closeDialog() {
        this.$emit('update:personalInfoVisible', false)
      },
      getUserStatus(val) {
        // 1正常 0禁用 -1未激活 2离职
        switch (val) {
          case 1:
            return this.$t('page.personalInfo.normal')
          case 0:
            return this.$t('page.personalInfo.disable')
          case -1:
            return this.$t('page.personalInfo.notActive')
          default:
            return this.$t('page.personalInfo.depart')
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .el-form-item {
    &__label::after {
      content: ':';
    }
    .item {
      width: 230px;
      height: 32px;
      color: $base-font-color;
      border-bottom: 1px solid $base-border-color;
    }
    &:nth-child(2n + 1) {
      margin-right: 50px;
    }
    ::v-deep .el-tag {
      margin: 0 10px 0 0;
    }
  }
</style>
